<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_hogar90.jpg" style="width: 100%" />
    <p class="tituloTarjeta">HOGAR 90</p>
    <p>
      <b>Por ser un cliente VIP </b>queremos premiar tu fidelidad y ahora por
      nuestro 90 aniversario
      <b>puedes asegurar tu hogar por tan solo 90€,</b> con las coberturas
      realmente importantes.
    </p>
    <p>
      <b>¡¡Precio GARANTIZADO!! sea como sea tu vivienda </b>
    </p>

    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button
          class="pure-button botonLlamar"
          title="Pulsa el botón para llamar a tu oficina MMT"
        >
          Llama e infórmate
        </button>
      </a>
    </p>
    <p class="container-flex">
      <a
        href="https://www.mmtseguros.com/hubfs/Bases_Campanas/Bases_90a%C3%B1os_2022.pdf"
        target="_blank"
        class="link"
        >Bases de la promoción</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
